//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopScreen from '~/components/TopScreen.vue'
import FooterTop from '~/components/footer/footerTop.vue'
import FeatureContainer from '~/components/forCompanies/FeatureContainer.vue'
import DescriptionCard from '~/components/forGaming/DescriptionCard.vue'
// import AnimatedLink from '~/components/common/AnimatedLink.vue'

export default {
  components: {
    TopScreen,
    FooterTop,
    FeatureContainer,
    DescriptionCard
    // AnimatedLink
  },
  head () {
    return {
      title: this.$t('footer.payment-methods.pix').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  },
  data () {
    return {
    }
  }
}
